<main class="p-4 container-lg">
  <h2 class="mb-3">Manage User Profile</h2>
  <div class="row">
    <div class="col-12 col-md-4">

      <h3>User/Password</h3>

      <div class="card mb-3">
        <div class="card-body">
          <h5>Email Address</h5>
          <p>{{email}}</p>
        </div>
      </div>
      

      <div class="card mb-3">
        <div class="card-body">
          <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
            <h5>Change Password</h5>

            <div class="from-group mb-3">
              <label for="currentPassword" class="form-label">Current password</label>
              <input type="password" class="form-control" formControlName="currentPassword" />
              <div class="text-danger" *ngIf="changePasswordFormControl.currentPassword.touched && changePasswordFormControl.currentPassword.errors?.required">
                Current password is required
              </div>
            </div>
            <div class="form-group mb-3">
              <label for="newPassword" class="form-label">New password</label>
              <input type="password" class="form-control" formControlName="newPassword"/>
              <div class="text-danger" *ngIf="changePasswordFormControl.newPassword.touched && changePasswordFormControl.newPassword.errors?.required">
                New password is required
              </div>
            </div>
            <div class="form-group mb-3">
              <label for="confirmNewPassword" class="form-label">Confirm new password</label>
              <input type="password" class="form-control" formControlName="confirmNewPassword" />
              <div class="text-danger" *ngIf="changePasswordFormControl.newPassword.touched && changePasswordFormControl.confirmNewPassword.touched && changePasswordForm.errors?.PasswordNoMatch">
                Passwords do not match.
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button type="submit" class="btn btn-primary mt-3">
                <i class="fa-solid fa-lock" [class]="{'fa-lock': !changingPassword, 'fa-spinner': changingPassword, 'fa-spin': changingPassword}"></i> Change Password
              </button>
            </div>
            <div class="alert alert-success mt-3" *ngIf="passwordChangeSuccess">
              Password changed successuflly!
            </div>
            <div class="alert alert-danger mt-3" *ngIf="passwordChangeFailed">
              Unable to change password. {{passwordChangeFailedDetail}}
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <h3>Payment/Subscription</h3>

      <div class="card mt-3">
        <div class="card-body">
          <h5>Subscription Information</h5>
          <p>
            Level: {{subscription?.subscriptionLevel}}
          </p>
          <p>
            AI Engineer:
            @if(subscription?.aiEngineerSubscriptionExpiration == null){
            Not Subscribed
            }
            @else{
            Expires {{subscription?.aiEngineerSubscriptionExpiration | date:'longDate'}}
            <button type="button" class="btn btn-sm btn-danger" (click)="cancelSubscription()" *ngIf="!subscription.isAIEngineerSubscriptionCancelled">Cancel</button>
            <span *ngIf="subscription.isAIEngineerSubscriptionCancelled"> (Canceled)</span>
            }
          </p>
          @if(subscription?.aiEngineerSubscriptionExpiration != null && !subscription?.isAIEngineerSubscriptionCancelled){
          <h5>Billing Portal</h5>
          <p>
            Recurring payments for GT Pro Tune AI Engineer is handled by Stripe. To update your payment method or view past invoices, visit the Billing Portal.
          </p>
          <p>
            <button type="button" class="btn btn-primary btn-sm" (click)="openBillingPortal()">Open Billing Portal <sup><i class="fa-solid fa-arrow-up-right-from-square"></i></sup></button>
          </p>
          }
          @if(subscription?.subscriptionLevel == 'Trial' || subscription?.subscriptionLevel == 'Lite' || !hasAIEngineerSubscription){
          <p>
            <a routerLink="/subscription">Upgrade Subscription</a>
          </p>
          }
        </div>
      </div>
    </div>
  </div>
</main>
